import React, { useEffect, useState } from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav, NamedLink, Button,
} from '../../components';
import { TopbarContainer } from '..';
import config from '../../config';
import css from './ManageSubscriptionPage.module.css';
import { post } from '../../util/api';

export const ManageSubscriptionPageComponent = props => {
  const {
    currentUser,
    scrollingDisabled,
    intl,
  } = props;

  const [customerPortalError, setCustomerPortalError] = useState(false);

  const ensuredCurrentUser = ensureCurrentUser(currentUser);

  const { publicData, privateData } = ensuredCurrentUser.attributes.profile;

  const goToCustomerPortal = () => {
    setCustomerPortalError(false)
    const body = { role: publicData?.userType, customerId: privateData?.stripeCustomerId };
    return post('/api/portal-session', body)
      .then(resp => window.open(resp.url, '_blank'))
      .catch(() => setCustomerPortalError(true));
  }

  const title = intl.formatMessage({ id: 'ManageSubscriptionPage.schemaTitle' });

  const currency = privateData?.subscriptionPlan?.currency === "gbp" ?
    config.currencySymbol :
    !!privateData?.subscriptionPlan?.currency ?
      privateData?.subscriptionPlan?.currency :
      config.currencySymbol;

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="ManageSubscriptionPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="ManageSubscriptionPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperAccountSettingsSideNav currentTab="ManageSubscriptionPage" />
        <LayoutWrapperMain>
          <div className={css.content}>
            {privateData?.subscription_plan_name ? (
              <div>
                <h1 className={css.title}>
                  <FormattedMessage id="ManageSubscriptionPage.title" />
                </h1>
                <h3>Current plan: {privateData.subscription_plan_name}</h3>
                <h3>Start date: {privateData.subscriptionStartDate}</h3>
                <h3>End date: {privateData.subscriptionEndDate}</h3>
                <h3>Price: {currency}{parseInt(privateData.subscriptionPlan.amount) / 100}</h3>

                <Button rootClassName={css.bookButton} onClick={() => goToCustomerPortal()}>
                  <FormattedMessage id="ManageSubscriptionPage.manageSusbcription" />
                </Button>
              </div>
            ) : publicData?.subscriptionLevel === 1 ? (
              <div>
                <h1 className={css.title}>
                  <FormattedMessage id="ManageSubscriptionPage.title" />
                </h1>
                <h3>Current plan: Freemium</h3>
                <h3>Price: Free</h3>

                <NamedLink className={css.bookButton} name="SubscriptionPage" >
                  <FormattedMessage id="ManageSubscriptionPage.manageSusbcription" />
                </NamedLink>
              </div>
            ) : (
              <div>
                <h1 className={css.title}>
                  <FormattedMessage id="ManageSubscriptionPage.noSubscriptionTitle" />
                </h1>

                <p>
                  <FormattedMessage
                    id="ManageSubscriptionPage.noSubscriptionDescription"
                    values={{
                      link: (
                        <NamedLink name="SubscriptionPage" className={css.link}>
                          <FormattedMessage id="ManageSubscriptionPage.here" />
                        </NamedLink>
                      )
                    }}
                  />
                </p>
              </div>
            )}
            {!!customerPortalError && (
              <p className={css.error}>
                <FormattedMessage id="ManageSubscriptionPage.portalError" />
              </p>
            )}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

ManageSubscriptionPageComponent.defaultProps = {
  currentUser: null,
};

ManageSubscriptionPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ManageSubscriptionPage = compose(connect(mapStateToProps), injectIntl)(ManageSubscriptionPageComponent);

export default ManageSubscriptionPage;
